/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowPersistedRule {
    getFixupPrototypeFunction() { return WorkFlowPersistedRule.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowPersistedRule>): WorkFlowPersistedRule {
        let obj = Object.assign(new WorkFlowPersistedRule(), model);
        WorkFlowPersistedRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowPersistedRule>): WorkFlowPersistedRule {
        if (!model) return null;
        return WorkFlowPersistedRule.newInstance(<WorkFlowPersistedRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowPersistedRule) {
        if (!obj) return;

        models.WorkFlowPersistedRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowPersistedRule): boolean {
        Object.setPrototypeOf(obj, WorkFlowPersistedRule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * master rule sys id
     */
    rule_id: string;

    /**
     * input parameters the user wants to override
     */
    default_inputs: Array<string>;

}
